/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable global-require */
import { ContractItem } from '@/ContractConfig';
import { ContractEnum } from '@/enums/contract-type';
import { BaseAgreementData } from '@/components/agreements';

interface ContractsByBankNameType {
  [commodityId: string]: {
    [bankName: string]: ContractItem[];
  };
}

// 根据渠道以及银行名称匹配额外的协议配置，目前只有杭银消金
const contractsByBankName: ContractsByBankNameType = {
  2050: {
    // 杭银消金
    中国建设银行: [
      {
        name: '《中国建设银行代收业务扣款授权协议》',
        url: require('@/assets/contracts/bindCard/zgjs_bank_card.txt.html'),
      },
    ],
    民生银行: [
      {
        name: '《民生银行委托代扣电子协议书》',
        url: require('@/assets/contracts/bindCard/ms_bank_card.txt.html'),
      },
    ],
    中国银行: [
      {
        name: '《中国银行股份有限公司借记卡快捷支付服务协议》',
        url: require('@/assets/contracts/bindCard/zg_bank_card.txt.html'),
      },
    ],
  },
};

export default class BindContracts extends BaseAgreementData {
  public async getContracts(params: {
    cardNo: string;
    cardName: string;
    commodityId: string;
    capitalCode?: string;
  }, options: Dictionary): Promise<ContractItem[]> {
    super.init(Number(params.commodityId), ContractEnum.BIND);

    await this.reloadNormal({
      cardNo: params.cardNo,
      bankName: params.cardName,
      capitalCode: params.capitalCode,
    }, undefined, options);

    if (contractsByBankName[params.commodityId]) {
      return [
        ...(this.infos.items || []),
        ...(contractsByBankName[params.commodityId][params.cardName] || []),
      ];
    }

    return this.infos.items || [];
  }
}
